import React, { Component } from "react"
import Utils from "../../../utils/node.utils"

class CategoryCheckBox extends Component {
  state = {
    checked: false,
  }

  componentDidMount() {
    const { category, checked, onClick } = this.props
    this.setState({
      checked: checked,
    })

    if (checked) {
      onClick(category, checked)
    }
  }

  onChange = cb => {
    const { onClick, category } = this.props

    if (window) {
      const params = Utils.ParseURLQuery(window.location.search)
      let newCategories = []

      if (cb.target.checked) {
        newCategories.push(category)
      }

      if (params.categories && params.categories !== "") {
        let splitCategories = params.categories.split(",")
        splitCategories = splitCategories.filter(c => c != category && c !== "")
        newCategories = newCategories.concat(splitCategories)
      }

      params.categories = newCategories.join()

      if (params.page) {
        params.page = 0
      }

      window.history.replaceState(
        {},
        "Shop",
        window.location.origin +
          window.location.pathname +
          Utils.CreateURLQuery(params)
      )
    }

    this.setState({
      checked: cb.target.checked,
    })
    onClick(category, cb.target.checked)
  }

  render() {
    const {
      onChange,
      props: { category },
      state: { checked },
    } = this

    return (
      <div className="form-group mb-1" key={category}>
        <div className="custom-control custom-checkbox">
          <input
            id={category}
            type="checkbox"
            name={category}
            className="custom-control-input"
            onChange={onChange}
            checked={checked}
            value={checked}
          />
          <label htmlFor={category} className="custom-control-label">
            {category}
          </label>
        </div>
      </div>
    )
  }
}

export default class CategoryFilter extends Component {
  state = {
    show: false,
  }

  componentDidMount() {
    const existingCategoryOpen = JSON.parse(
      sessionStorage.getItem("category-open")
    )
    if (existingCategoryOpen) {
      if (existingCategoryOpen.categoryOpen) {
        this.setState({
          show: existingCategoryOpen.categoryOpen,
        })
      }
    }
  }

  onCollapse = event => {
    const { show } = this.state
    event.preventDefault()
    sessionStorage.setItem(
      "category-open",
      JSON.stringify({ categoryOpen: !show })
    )
    this.setState({
      show: !show,
    })
  }

  onCategoryClick = (category, checked) => {
    const { onCategoryClick } = this.props

    onCategoryClick(category, checked)
  }

  getShow = () => {
    return this.state.show ? " show" : ""
  }

  render() {
    const {
      state: { show },
      props: { categories, language, contentMap },
      onCategoryClick,
      onCollapse,
      getShow,
    } = this

    return (
      <div className="sidebar-block px-3 px-lg-0 mr-lg-4">
        <a
          data-toggle="collapse"
          href="#"
          title={contentMap.filter_by_category.value}
          aria-expanded={show}
          aria-controls="categoryFilterMenu"
          className="d-lg-none block-toggler"
          onClick={onCollapse}
        >
          {contentMap.filter_by_category.value}
        </a>
        <div
          id="categoryFilterMenu"
          className={"expand-lg collapse" + getShow()}
        >
          <h6 className="sidebar-heading d-none d-lg-block">
            {contentMap.filter_categories.value}
          </h6>
          <form action="#" className="mt-4 mt-lg-0">
            {Object.keys(categories)
              .sort()
              .map(category => {
                return (
                  <CategoryCheckBox
                    key={category}
                    category={category}
                    onClick={onCategoryClick}
                    checked={categories[category]}
                    language={language}
                  />
                )
              })}
          </form>
        </div>
      </div>
    )
  }
}
